import React, { useState, useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";

import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";

import CircularProgresss from "components/CircularProgress/CircularProgresss";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import ToastModal from "views/components/ToastModal";
import { masterCategory } from "assets/properties/properties";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";

const MasterCategoryCreate = ({ props, classes }) => {
  const navigate = useNavigate();
  const params = useParams();

  const { authToken } = useSelector((state) => state.login.authData);

  const outletData = useOutletContext();

  const thirdPartyServiceNameFlag =
    typeof outletData?.thirdPartyServiceNameFlag === "string"
      ? JSON.parse(outletData?.thirdPartyServiceNameFlag)
      : outletData?.thirdPartyServiceNameFlag;

  const [name, setName] = useState("");
  const [nameState, setNameState] = useState(false);

  const [code, setCode] = useState("");
  const [codeState, setCodeState] = useState(false);

  const [description, setDescription] = useState("");
  const [descriptionState, setDescriptionState] = useState(false);

  const [disabledButton, setDisabledButton] = useState(true);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const [redirectURL, setRedirectURL] = useState("");

  const [callInProgress, setCallInProgress] = useState(false);

  useEffect(() => {
    (async () => {
      if (params?.id) {
        setCallInProgress(true);

        const result = await apiHandler({
          url: endpoint.MASTER_CATEGORY_FINDALL,
          authToken,
        });

        setCallInProgress(false);

        const filteredData = result?.data?.filter(
          (item) => item?.id === Number(params?.id)
        );

        if (filteredData?.length > 0) {
          const data = filteredData[0];

          setName(data?.name || "");
          setCode(data?.code || "");
          setDescription(data?.description || "");
        }
      }
    })();
  }, []);

  useEffect(() => {
    if (
      name &&
      code &&
      description 
    ) {
      setDisabledButton(false);
    } else {
      setDisabledButton(true);
    }
  }, [name, code, description]);

  // Toast Message
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);

    if (redirectURL !== "") {
      navigate(redirectURL);
      setRedirectURL("");
    }
  };

  const editInformation = async () => {
    setCallInProgress(true);

    const res = await apiHandler({
      url: endpoint.MASTER_CATEGORY_UPDATE  + params?.id,
      method: "PUT",
      authToken,
      data: {
        code,
        name,
        description,
      },
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    }

    return "SUCCESS";
  };

  const saveInformation = async () => {
    setCallInProgress(true);

    const res = await apiHandler({
      url: endpoint.MASTER_CATEGORY_CREATE,
      method: "POST",
      authToken,
      data: {
        code,
        name,
        description,
      },
    });

    setCallInProgress(false);

    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return "ERROR";
    }

    return "SUCCESS";
  };

  const handleDiscrepancySubmit = async () => {
    toastUpdate("", "", false);

    let status = "";

    if (params?.id) {
      status = await editInformation();
    } else {
      status = await saveInformation();
    }

    if (status === "SUCCESS") {
      const msg = params?.id
        ? "Master Category updated successfully!"
        : "Master Category created successfully!";

      toastUpdate("Success", msg, true);

      setRedirectURL("/coreservice/MasterCategory");
    }
  };

  const handleCancel = () => {
    navigate("/coreservice/MasterCategory");
  };

  return (
    <Grid container>
      <Grid item xs={12}>
        <SubHeader
          label={
            params?.id
              ? "Edit Master Category"
              : "Create Master Category"
          }
          button1="Save"
          button2="Cancel"
          button1click={handleDiscrepancySubmit}
          button2click={handleCancel}
          disabled1={disabledButton}
        />
      </Grid>

      <Grid
        item
        xs={12}
        className={classes.inputContainer}
      >
        <Grid
          container
          className={classes.inputFieldContainer}
          spacing={2}
        >
             {/* Code */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
          >
             <CustomSelectNew
              label="Code"
              id="code"
              error={codeState}
              value={code}
              setState={setCode}
              setError={setCodeState}
              data={masterCategory}
              type="partnerName"
              disabled={params?.id ? true : false}
            />
          </Grid>
          {/* Name */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
          >
            <CustomeTextField
              label="Name"
              required
              error={nameState}
              id="name"
              value={name}
              setState={setName}
              setError={setNameState}
              type="notCapital"
            />
          </Grid>

          {/* Description */}
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            className={classes.fieldContaienr}
          >
            <CustomeTextField
              label="Description"
              required
              error={descriptionState}
              id="description"
              value={description}
              setState={setDescription}
              setError={setDescriptionState}
              type="notCapital"
            />
          </Grid>
        </Grid>
      </Grid>

      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}

      {callInProgress && (
        <CircularProgresss
          callInProgress={callInProgress}
        />
      )}
    </Grid>
  );
};

export default MasterCategoryCreate;